import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {isLoggedIn} from "./AuthService";

export const PrivateRoute = ({component: Component, ...rest}) => (

    <Route {...rest} render={props =>(
        isLoggedIn()?
            <Component {...props} {...rest} /> :
            <Redirect to={{pathname: '/', state: {from: props.location}}}/>
    )}/>
);


// WEBPACK FOOTER //
// ./src/controller/PrivatePath.jsx